class ExtratoNfeIcmsService extends EficienciaFiscalAbstractService

  configure: (configs, injector) ->
    configs.url = '/eficiencia-fiscal/extrato-nfe-icms'

    super(configs, injector)

  checarContrato: (contrato, callback) ->
    @getList({contrato: contrato, q: 'check-only'}, callback)

  emitir: (params) ->
    url = @pathService.getApiUrl() + @pathService.parametrize(@configs.getUrl(), params)

    cbk.download url

angular.module('eficienciaFiscalModule').service('extratoNfeIcmsService', ExtratoNfeIcmsService)
